
import React from 'react';
import { Box, TableCell, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const DescriptionContainer = styled('div')({
  lineHeight: 1.2,
  verticalAlign: 'top',
  '& p': {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    verticalAlign: 'top',
  },
  '& *': {
    marginTop: 0,
    paddingTop: 0,
  },
});

const InfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F3F6FE',
  padding: theme.spacing(2),
  borderRadius: '4px',
  marginTop: theme.spacing(2),
  boxSizing: 'border-box',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}));

const InfoTable = styled('div')({
  display: 'table',
  width: '100%',
  textAlign: 'left',
});

const TableRowStyled = styled('div')({
  display: 'table-row',
});

const TableCellStyled = styled(TableCell)(({ theme }) => ({
  display: 'table-cell',
  padding: theme.spacing(0.5),
  border: 'none',
}));

const ContentWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  paddingBottom: theme.spacing(4),
}));

export type FormCardContentProps = {
  createdDate: string;
  createdTime: string;
  createdBy: string;
  updatedDate: string;
  updatedTime: string;
  updatedBy: string;
  status: string;
  title: string;
  description: string;
  roles: string[];
  formType?: string;
  isExtension?: boolean;
  parentFormName?: string;
};

const FormCardContent = ({
  description,
  createdDate,
  createdTime,
  createdBy,
  updatedDate,
  updatedTime,
  updatedBy,
}: FormCardContentProps): JSX.Element => {
  return (
    <ContentWrapper data-testid="FormCardContent">
      {/* Description */}
       {/* Description */}
      {/* Show ellipsis only if description is long, else show full */}
      {description && description.replace(/<[^>]+>/g, '').length > 200 ? (
        <DescriptionContainer
          style={{
            textAlign: 'left',
            marginLeft: 20,
            marginRight: 20,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
          }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      ) : (
        <DescriptionContainer
          style={{ textAlign: 'left', marginLeft: 20 }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {/* <Typography
        variant="body1"
        component="p"
        style={{
          textAlign: "left",
          marginLeft: "20px",
          marginTop: theme.spacing(1),
        }}
      >
        This is the second line of description. It provides more information
        about the form details.
      </Typography> */}

      {/* Info Box for created/updated details */}
      <InfoBox data-testid="infoBox">
        <InfoTable>

          <TableRowStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                Created
              </Typography>
            </TableCellStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                {createdDate}
              </Typography>
            </TableCellStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                {createdTime}
              </Typography>
            </TableCellStyled>
          </TableRowStyled>

          <TableRowStyled >
            <TableCellStyled colSpan={3}>
              <Typography variant="body1" component="p">
                {createdBy}
              </Typography>
            </TableCellStyled>
          </TableRowStyled>

          <TableRowStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                Updated
              </Typography>
            </TableCellStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                {updatedDate}
              </Typography>
            </TableCellStyled>
            <TableCellStyled>
              <Typography variant="body1" component="p">
                {updatedTime}
              </Typography>
            </TableCellStyled>
          </TableRowStyled>

          <TableRowStyled >
            <TableCellStyled colSpan={3}>
              <Typography variant="body1" component="p">
                {updatedBy}
              </Typography>
            </TableCellStyled>
          </TableRowStyled>

        </InfoTable>
      </InfoBox>
    </ContentWrapper>
  );
};

export default FormCardContent;
